/* eslint no-unused-expressions: "off" */
/* eslint eqeqeq: "off" */
/* eslint no-sequences: "off" */

// Encryption class for creating a request token.
export default class E {
  static encrypt(e, t) {
    if (((e = String(e)), (t = String(t)), 0 == e.length)) return "";
    const n = E.strToLongs(E.utf8Encode(e)),
      r = E.strToLongs(E.utf8Encode(t).slice(0, 16)),
      o = E.encode(n, r),
      a = E.longsToStr(o);
    return E.base64Encode(a);
  }
  static encode(e, t) {
    e.length < 2 && (e[1] = 0);
    const n = e.length;
    let r,
      o,
      a = Math.floor(6 + 52 / n),
      c = e[n - 1],
      s = e[0],
      f = 0;
    for (; a-- > 0; ) {
      o = ((f += 2654435769) >>> 2) & 3;
      for (let a = 0; a < n; a++)
        (r =
          (((c >>> 5) ^ ((s = e[(a + 1) % n]) << 2)) + ((s >>> 3) ^ (c << 4))) ^
          ((f ^ s) + (t[(3 & a) ^ o] ^ c))),
          (c = e[a] += r);
    }
    return e;
  }
  static strToLongs(e) {
    const t = new Array(Math.ceil(e.length / 4));
    for (let n = 0; n < t.length; n++)
      t[n] =
        e.charCodeAt(4 * n) +
        (e.charCodeAt(4 * n + 1) << 8) +
        (e.charCodeAt(4 * n + 2) << 16) +
        (e.charCodeAt(4 * n + 3) << 24);
    return t;
  }
  static longsToStr(e) {
    let t = "";
    for (let n = 0; n < e.length; n++)
      t += String.fromCharCode(
        255 & e[n],
        (e[n] >>> 8) & 255,
        (e[n] >>> 16) & 255,
        (e[n] >>> 24) & 255
      );
    return t;
  }
  static utf8Encode(e) {
    return unescape(encodeURIComponent(e));
  }
  static base64Encode(e) {
    if ("undefined" != typeof btoa) return btoa(e);
    if ("undefined" != typeof Buffer)
      return new Buffer(e, "binary").toString("base64");
    throw new Error("No Base64 Encode");
  }
}
